import { CSSProperties, FC } from 'react';
import { generateIcon, IIconSetting } from './Icon';

interface IValueNotFoundProps {
    iconSetting?: IIconSetting;
    title?: string;
    cssproperties?: CSSProperties;
}

const ValueNotFound: FC<IValueNotFoundProps> = (props) => {
    const { iconSetting, title, cssproperties } = props;

    return (
        <div className="value-not-found" style={cssproperties}>
            {generateIcon(iconSetting)}
            <span className="title">{title}</span>
            {props.children}
        </div>
    )
}

export default ValueNotFound;